import React from 'react'
import Header from '../../../../Header/Header'
import Navigationbar from '../../../../Navigationbar/Navigationbar'

const CSCEIMS = (props) => {
  return (
    <div className='' style={{ display: 'flex', flexDirection: 'column', height: '70vh' }}>
      {/* <Header {...props} />
      <Navigationbar {...props} /> */}
      <div style={{ flex: 1}}>
        <iframe
          src={props.url}
          style={{ width: '100%', height: '70vh', border: 'none' }}
          title="Chat Support"
        />
      </div>
    </div>
  )
}

export default CSCEIMS
